@if (tableData && dataSource) {
  <div class="table-wrapper">
    <table
      mat-table
      [dataSource]="dataSource"
      [trackBy]="trackByFn"
      multiTemplateDataRows
      matSort
      [ngClass]="{ 'has-subtables': tableData.isExpandButtonVisible, 'table-normal': !tableData.scrollMode }"
      >
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      @if (tableData.isExpandButtonVisible) {
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="tableData.displayedColumns.length + 1">
            <div
              [@detailExpand]="
                element &&
                expandedElement &&
                element[tableData.expandElementCompareColumn] === expandedElement[tableData.expandElementCompareColumn]
                  ? 'expanded'
                  : 'collapsed'
              "
              style="overflow: hidden"
              >
              <lgv-sub-table-item
                style="overflow-x: scroll"
                [displayedColumns]="tableData.subDisplayedColumns"
                [data]="element.subitems"
                (textClickClicked)="onSubTableTextClicked($event, element)"
              ></lgv-sub-table-item>
            </div>
          </td>
        </ng-container>
      }
      @if (tableData.multiSelectFirst || tableData.multiSelectLast) {
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 75px">
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()"
              color="primary"
              >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="table-data" style="width: 75px">
            @if (!row.footer) {
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
                [aria-label]="checkboxLabel(row)"
                color="primary"
                >
              </mat-checkbox>
            }
          </td>
        </ng-container>
      }
      @for (item of tableData.displayedColumns; track item) {
        <ng-container [matColumnDef]="item.prop">
          <th
            class="table-header"
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            [disabled]="!item.sort ? true : false"
            style="user-select: none"
            [style.width]="item.columnWidth ? item.columnWidth : ''"
            [style.textAlign]="item.headerCentered ? 'center' : undefined"
            [ngClass]="{
              'icon-header':
                item.type === 'edit' ||
                item.type === 'delete' ||
                item.type === 'download' ||
                item.type === 'downloadOptional' ||
                item.type === 'downloadSignature' ||
                item.type === 'openButton' ||
                item.type === 'expandButton' ||
                item.type === 'star',
              'image-table-header': item.type === 'image',
              'user-more-header':
                item.type === 'userMore' ||
                item.type === 'userAdminMore' ||
                item.type === 'requestMore' ||
                item.type === 'organisationMore' ||
                item.type === 'editDeleteMore' ||
                item.type === 'diaryMore',
              'table-header-center': tableData.centerContent,
            }"
            >
            <span [style.color]="item.marked ? 'red' : 'unset'">
              {{ item.trans | translate }}
            </span>
          </th>
          <td
            class="table-data"
            mat-cell
            *matCellDef="let element"
            [ngClass]="{
              'icon-data':
                item.type === 'edit' ||
                item.type === 'delete' ||
                item.type === 'download' ||
                item.type === 'downloadOptional' ||
                item.type === 'downloadSignature' ||
                item.type === 'openButton' ||
                item.type === 'expandButton' ||
                item.type === 'star',
              'image-table-data': item.type === 'image',
              'image-table-header': item.type === 'image',
              'table-data-center': tableData.centerContent,
            }"
            [style.width]="item.columnWidth ? item.columnWidth : ''"
            >
            <!-- It is possible to hide to content of some columns for nested tables but still keep the column. -->
            @if (isSubtable ? !item.hiddenForSubtable : true) {
              @if (item.type === 'text') {
                <span matTooltipPosition="before" [matTooltip]="element[item.prop]">
                  {{ element[item.prop] ?? '-' }}
                </span>
              }
              @if (item.type === 'currency') {
                <span matTooltipPosition="before" [matTooltip]="element[item.prop]">
                  {{ element[item.prop] ? (element[item.prop] | currency: item.format : '') : '-' }}
                </span>
              }
              @if (item.type === 'colorGreen') {
                <span matTooltipPosition="before" [matTooltip]="element[item.prop]" style="color: #4caf50">
                  {{ element[item.prop] ? element[item.prop] : '-' }}
                </span>
              }
              @if (item.type === 'clickText') {
                <span
                  matTooltipPosition="before"
                  [matTooltip]="element[item.prop]"
                  style="text-align: center"
                  [ngStyle]="{ cursor: !element.footer ? 'pointer' : 'default' }"
                  (click)="!element.footer ? onClickTextClicked($event, element, item.prop) : null"
                  >
                  {{ element[item.prop] ? element[item.prop] : '' }}
                  @if (!element[item.prop]) {
                    <div style="text-align: center">-</div>
                  }
                </span>
              }
              @if (item.type === 'reportingDetailsItem') {
                <span
                  style="position: relative"
                  [ngStyle]="{ cursor: !element.footer ? 'pointer' : 'default' }"
                  (click)="!element.footer ? onClickTextClicked($event, element, item.prop) : null"
                  >
                  @if (
                    element[item.prop] &&
                    element[item.prop].isForfait &&
                    (element[item.prop].plannedQ > 0 || element[item.prop].workedQ > 0)
                    ) {
                    <div
                      style="display: flex; justify-content: center"
                      [style]="element[item.prop].allIsSynedFromPlatform ? 'text-decoration: underline' : ''"
                      >
                      <div>{{ element[item.prop].plannedQ }}</div>
                      <div>/</div>
                      <div style="color: #4caf50">{{ element[item.prop].workedQ }}</div>
                    </div>
                  }
                  @if (
                    element[item.prop] &&
                    !element[item.prop].isForfait &&
                    (element[item.prop].plannedH > 0 || element[item.prop].workedH > 0)
                    ) {
                    <div
                      style="display: flex; justify-content: center"
                      [style]="element[item.prop].allIsSynedFromPlatform ? 'text-decoration: underline' : ''"
                      >
                      <div>{{ hourFormatter(element[item.prop].plannedH) }}</div>
                      <div>/</div>
                      <div style="color: #4caf50">{{ hourFormatter(element[item.prop].workedH) }}</div>
                    </div>
                  }
                  @if (!element[item.prop] || !element[item.prop].hasReportingHours) {
                    <div style="text-align: center">-</div>
                  }
                  @if (element[item.prop] && (element[item.prop].hasAbsence || element[item.prop].hasNoShowNotes)) {
                    <div style="color: red; position: absolute; top: -16px; right: 0px">
                      {{ element[item.prop].hasAbsence ? 'X' : '' }}
                      {{ element[item.prop].hasNoShowNotes ? 'N' : '' }}
                    </div>
                  }
                </span>
              }
              @if (item.type === 'translate') {
                <span matTooltipPosition="before" [matTooltip]="element[item.prop] | translate">
                  {{ element[item.prop] ? (element[item.prop] | translate) : '-' }}
                </span>
              }
              @if (item.type === 'subtext') {
                <lgv-subtext-table-item [item]="element" [column]="item"></lgv-subtext-table-item>
              }
              @if (item.type === 'star' && (element?.status === 'open' || element?.status === 'starred')) {
                <lgv-star-table-item
                  [value]="element?.status === 'starred'"
                  (valueChange)="starRowEvent.emit(element)"
                ></lgv-star-table-item>
              }
              @if (item.type === 'subsubtext') {
                <lgv-subsubtext-table-item [item]="element" [column]="item"></lgv-subsubtext-table-item>
              }
              @if (item.type === 'bool') {
                <lgv-bool-table-item [value]="element[item.prop]"> </lgv-bool-table-item>
              }
              @if (item.type === 'delete') {
                <lgv-icon-table-item
                  icon="delete"
                  tooltip="Delete"
                  (click)="$event.stopPropagation()"
                  (onClicked)="deleteRowEvent.emit(element)"
                  >
                </lgv-icon-table-item>
              }
              @if (item.type === 'edit') {
                <lgv-icon-table-item
                  icon="edit"
                  tooltip="Edit"
                  (click)="$event.stopPropagation()"
                  (onClicked)="updateRowEvent.emit(element)"
                  >
                </lgv-icon-table-item>
              }
              @if (item.type === 'downloadSignature' && element['status'] === 'approved') {
                <lgv-icon-table-item
                  icon="file_download"
                  tooltip="Download"
                  (click)="$event.stopPropagation()"
                  (onClicked)="downloadRowEvent.emit(element)"
                  >
                </lgv-icon-table-item>
              }
              @if (item.type === 'download') {
                <lgv-icon-table-item
                  icon="file_download"
                  tooltip="Download"
                  (click)="$event.stopPropagation()"
                  (onClicked)="downloadRowEvent.emit(element)"
                  >
                </lgv-icon-table-item>
              }
              @if (item.type === 'downloadOptional' && element[item.prop]) {
                <lgv-icon-table-item
                  icon="file_download"
                  tooltip="Download"
                  (click)="$event.stopPropagation()"
                  (onClicked)="downloadRowEvent.emit(element)"
                  >
                </lgv-icon-table-item>
              }
              @if (item.type === 'openButton') {
                <lgv-icon-table-item
                  icon="open_in_new"
                  tooltip="Open"
                  (click)="$event.stopPropagation()"
                  (onClicked)="openButtonRowEvent.emit(element)"
                  >
                </lgv-icon-table-item>
              }
              @if (item.type === 'image') {
                <lgv-image-table-item
                  [id]="element[item.prop]"
                  [defaultPicture]="tableData.defaultPicture"
                ></lgv-image-table-item>
              }
              @if (item.type === 'datetime') {
                <lgv-date-table-item [format]="item.format" [date]="element[item.prop]"></lgv-date-table-item>
              }
              @if (item.type === 'numeric') {
                <lgv-numeric-table-item [format]="item.format" [value]="element[item.prop]"></lgv-numeric-table-item>
              }
              @if (item.type === 'hoursMinutes') {
                <lgv-hours-minutes-table-item [value]="element[item.prop]"></lgv-hours-minutes-table-item>
              }
              @if (item.type === 'hoursMinutesGreen') {
                <lgv-hours-minutes-table-item
                  [value]="element[item.prop]"
                  style="color: #4caf50"
                ></lgv-hours-minutes-table-item>
              }
              @if (item.type === 'downloadFile') {
                <lgv-download-table-item [value]="element[item.prop]"></lgv-download-table-item>
              }
              @if (item.type === 'audio') {
                <lgv-audio-table-item [value]="element[item.prop]"></lgv-audio-table-item>
              }
              @if (item.type === 'userAdminMore') {
                <lgv-user-admin-more-table-item
                  [user]="element"
                  (editClicked)="updateRowEvent.emit(element)"
                  (deleteClicked)="deleteRowEvent.emit(element)"
                  (sendInviteClicked)="sendInviteEvent.emit(element)"
                  (enableAccountClicked)="changeAccountStatus(element, true)"
                  (disableAccountClicked)="changeAccountStatus(element, false)"
                  (click)="$event.stopPropagation()"
                ></lgv-user-admin-more-table-item>
              }
              @if (item.type === 'userMore') {
                <lgv-user-more-table-item
                  [user]="element"
                  [currentUser]="getCurrentUser()"
                  (editClicked)="updateRowEvent.emit(element)"
                  (deleteClicked)="deleteRowEvent.emit(element)"
                  (sendInviteClicked)="sendInviteEvent.emit(element)"
                  (enableAccountClicked)="changeAccountStatus(element, true)"
                  (disableAccountClicked)="changeAccountStatus(element, false)"
                  (click)="$event.stopPropagation()"
                ></lgv-user-more-table-item>
              }
              @if (item.type === 'diaryMore') {
                <lgv-diary-more-table-item
                  [diary]="element"
                  (editClicked)="updateRowEvent.emit(element)"
                  (readClicked)="readRowEvent.emit(element)"
                  (deleteClicked)="deleteRowEvent.emit(element)"
                  (click)="$event.stopPropagation()"
                ></lgv-diary-more-table-item>
              }
              @if (item.type === 'requestMore') {
                <lgv-request-table-more-item
                  [item]="element"
                  (editClicked)="updateRowEvent.emit(element)"
                  (deleteClicked)="deleteRowEvent.emit(element)"
                  (archiveClicked)="archiveRowEvent.emit(element)"
                  (unarchiveClicked)="unarchiveRowEvent.emit(element)"
                  (click)="$event.stopPropagation()"
                  >
                </lgv-request-table-more-item>
              }
              @if (item.type === 'editDeleteMore') {
                <lgv-edit-delete-table-more-item
                  (editClicked)="updateRowEvent.emit(element)"
                  (deleteClicked)="deleteRowEvent.emit(element)"
                  (click)="$event.stopPropagation()"
                  >
                </lgv-edit-delete-table-more-item>
              }
              @if (item.type === 'organisationMore') {
                <lgv-organisation-more-table-item
                  (editClicked)="updateRowEvent.emit(element)"
                  (deleteClicked)="deleteRowEvent.emit(element)"
                  (permissionClicked)="permissionRowEvent.emit(element)"
                  (click)="$event.stopPropagation()"
                  >
                </lgv-organisation-more-table-item>
              }
              @if (item.type === 'status') {
                <lgv-status-table-item [value]="element[item.prop]"></lgv-status-table-item>
              }
              @if (item.type === 'requestLink') {
                <lgv-request-link-table-item
                  [data]="element[item.prop]"
                  [link]="item.link"
                ></lgv-request-link-table-item>
              }
              @if (tableData.isExpandButtonVisible && item.type === 'expandButton' && element.subItemsCount >= 1) {
                <button
                  mat-icon-button
                  style="padding: 10px"
                  (click)="$event.stopPropagation(); onExpandRowClick(element)"
                  >
                  @if (
                    !expandedElement ||
                    (expandedElement &&
                    element[tableData.expandElementCompareColumn] !==
                    expandedElement[tableData.expandElementCompareColumn])
                    ) {
                    <mat-icon>add</mat-icon>
                  }
                  @if (
                    element &&
                    expandedElement &&
                    element[tableData.expandElementCompareColumn] ===
                    expandedElement[tableData.expandElementCompareColumn]
                    ) {
                    <mat-icon>remove</mat-icon>
                  }
                </button>
              }
            }
          </td>
        </ng-container>
      }
      @if (!tableData.hideTableColumnHeaders) {
        <tr class="table-header-row" mat-header-row *matHeaderRowDef="getProps()"></tr>
      }
      <tr
        (click)="getRow(row)"
        class="table-data-rows default-row-height"
        [style.borderLeft]="row.rowColor ? row.rowColor : undefined"
        mat-row
        *matRowDef="let row; columns: getProps()"
        [ngClass]="{
          clickable: tableData.clickableRow && !row.disableClick,
        }"
        (click)="!row.footer && tableData.clickableRow ? selection.toggle(row) : null"
      ></tr>
      @if (tableData.isExpandButtonVisible) {
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      }
    </table>
    @if (tableData.isPaginatorVisible) {
      <mat-paginator
        class="custom-paginator"
        [hidePageSize]="true"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="page - 1"
        (page)="pageEvent = $event"
      ></mat-paginator>
    }
  </div>
}
